// Leaf constants — kept out of RewardTypeSection.tsx so pure-function modules
// (validators, payload translators, campaignFormValidation) can import them
// without dragging in antd / components/Layout/Form. The Form module reads
// `antInput.TextArea` at module init, which throws under test harnesses that
// don't initialize antd.

export const REWARD_MODE_FIXED = 'fixed';
export const REWARD_MODE_TIER_BASED = 'tier_based';

export type TReferralRewardModeValue = typeof REWARD_MODE_FIXED | typeof REWARD_MODE_TIER_BASED;
